// Presentation text only: provider identifiers, credentials and URLs stay intact.
const PROVIDER_NAME = /eleven[\s_-]*labs|\b11labs\b/gi;
export const voiceDisplayText = (value) =>
  typeof value === "string"
    ? value.replace(PROVIDER_NAME, (match, offset) => /^\s+voice\b/i.test(value.slice(offset + match.length)) ? "Phloz" : "Phloz Voice")
    : value;

const voiceDisplayHtml = (value) => {
  if (voiceDisplayText(value) === value) return value;
  const document = new DOMParser().parseFromString(value, "text/html");
  const walker = document.createTreeWalker(document.body, 4);
  while (walker.nextNode()) {
    if (!["SCRIPT", "STYLE"].includes(walker.currentNode.parentElement?.tagName)) {
      walker.currentNode.nodeValue = voiceDisplayText(walker.currentNode.nodeValue);
    }
  }
  document.querySelectorAll("[title], [alt], [aria-label]").forEach((node) => {
    ["title", "alt", "aria-label"].forEach((attribute) => {
      if (node.hasAttribute(attribute)) node.setAttribute(attribute, voiceDisplayText(node.getAttribute(attribute)));
    });
  });
  return /<html[\s>]/i.test(value) ? document.documentElement.outerHTML : document.body.innerHTML;
};

const DISPLAY_FIELDS = new Set([
  "Content", "name", "Name", "label", "actorLabel", "action", "title", "description",
  "reason", "summary", "teaser", "message", "error", "errorMessage", "details",
  "body", "content", "text", "subject", "agentName", "agent__name", "elevenlabsAgentName",
  "journeySummary", "handoverReason", "dispositionReason", "satisfactionReason",
  "effectivenessSummary", "callerQuery", "originalBotResponse", "trainingPrompt",
  "latestSummary", "note", "html", "htmlBody",
]);

export function brandUiResponse(value, field = "") {
  if (typeof value === "string") {
    if (["html", "htmlBody"].includes(field)) return voiceDisplayHtml(value);
    return DISPLAY_FIELDS.has(field) ? voiceDisplayText(value) : value;
  }
  if (Array.isArray(value)) return value.map((item) => brandUiResponse(item, field));
  if (!value || typeof value !== "object" || Object.getPrototypeOf(value) !== Object.prototype) return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, brandUiResponse(item, key)]));
}
